import React from 'react'

export const Iframe = ({ url, iframeVideoRef, triggerAutoPlay }) => {
  return (
    <iframe
      className="explainer-video-mobile"
      title="explainer-video"
      allowFullScreen={true}
      frameBorder="0"
      src={url}
      ref={iframeVideoRef}
      onLoad={triggerAutoPlay}
    />
  )
}
